/*
 * worksAction.js
 * trt_cms2
 *
 * Created by Hisyam on 09/03/2020, 4:22 PM.
 * Copyright (c) 2020 Terato Tech. All rights reserved.
 */

import {
  ADD_CAREER,
  ADD_CAREER_FULFILLED,
  ADD_WORK,
  ADD_WORK_FULFILLED, DELETE_CAREER, DELETE_CAREER_FULFILLED, DELETE_WORK, DELETE_WORK_FULFILLED,
  FETCH_CAREER,
  FETCH_CAREER_FULFILLED,
  FETCH_CAREERS,
  FETCH_CAREERS_FULFILLED,
  FETCH_WORK,
  FETCH_WORK_FULFILLED,
  FETCH_WORKS,
  FETCH_WORKS_FULFILLED,
  NEW_CAREER,
  NEW_CAREER_FULFILLED,
  NEW_WORK,
  NEW_WORK_FULFILLED, RESET_REDIRECT_CAREER, RESET_REDIRECT_WORK,
  UPDATE_CAREER,
  UPDATE_CAREER_FULFILLED,
  UPDATE_WORK,
  UPDATE_WORK_FULFILLED
} from "../types";
import {ofType} from "redux-observable";
import {catchError, debounceTime, map, mapTo, switchMap, withLatestFrom} from "rxjs/operators";
import {ajax} from "rxjs/ajax";
import {
  CAREER_CATEGORIES_API,
  CAREERS_API,
  WORK_DELIVERABLES_API,
  WORK_PLATFORMS_API,
  WORKS_API
} from "../../config/api";
import {apiHeader, encodeQueryData} from "../../config/helper";
import {forkJoin, of} from "rxjs";
import {returnErrors} from "../messages/messagesAction";

export const fetchWorks = (limit, offset, params={}) => ({type: FETCH_WORKS, payload: {limit: limit, offset: offset, ...params}});
const fetchWorksFulfilled = (payload) => ({type: FETCH_WORKS_FULFILLED, payload: payload});
export const fetchWorksEpic = (action$, state$) => action$.pipe(
  ofType(FETCH_WORKS),
  debounceTime(500),
  withLatestFrom(state$),
  switchMap(([action, state]) => ajax.getJSON(WORKS_API + `?${encodeQueryData(action.payload)}`, apiHeader(state)).pipe(
    map(response => fetchWorksFulfilled(response)),
    catchError(({response, status}) => of(returnErrors(response, status)))
  ))
);

const deliverablesAjax$ = (state) => {
  return state.works.deliverables.length >= 1 ? of(state.works.deliverables) : ajax.getJSON(WORK_DELIVERABLES_API, apiHeader(state))
    .pipe(map(deliverables => deliverables.map(deliverable => ({
      value: deliverable.id,
      label: deliverable.name,
    }))))
};
const platformsAjax$ = state => {
  return state.works.platforms.length >= 1 ? of(state.works.platforms) : ajax.getJSON(WORK_PLATFORMS_API, apiHeader(state))
    .pipe(map(platforms => platforms.map(platform => ({
      value: platform.id,
      label: platform.name,
    }))))
};

export const newWork = () => ({type: NEW_WORK});
const newWorkFulfilled = payload => ({type: NEW_WORK_FULFILLED, payload: payload});
export const newWorkEpic = (action$, state$) => action$.pipe(
  ofType(NEW_WORK),
  withLatestFrom(state$),
  switchMap(([action, state]) => forkJoin({
    deliverables: deliverablesAjax$(state),
    platforms: platformsAjax$(state)
  }).pipe(
    map(response => newWorkFulfilled(response)),
    catchError(({response, status}) => of(returnErrors(response, status)))
  ))
);

export const fetchWork = (id) => ({type: FETCH_WORK, payload: id});
const fetchWorkFulfilled = payload => ({type: FETCH_WORK_FULFILLED, payload: payload});
export const fetchWorkEpic = (action$, state$) => action$.pipe(
  ofType(FETCH_WORK),
  withLatestFrom(state$),
  switchMap(([action, state]) => forkJoin({
    work: ajax.getJSON(WORKS_API + `${action.payload}/`, apiHeader(state)),
    deliverables: deliverablesAjax$(state),
    platforms: platformsAjax$(state),
  }).pipe(
    map((response) => fetchWorkFulfilled(response)),
    catchError(({response, status}) => of(returnErrors(response, status)))
  )),
);

export const addWork = (work) => ({type: ADD_WORK, payload: work});
const addWorkFulfilled = (payload) => ({type: ADD_WORK_FULFILLED, payload: payload});
export const addWorkEpic = (action$, state$) => action$.pipe(
  ofType(ADD_WORK),
  debounceTime(500),
  withLatestFrom(state$),
  switchMap(([action, state]) => ajax.post(WORKS_API, action.payload, apiHeader(state))
    .pipe(
      map(({response}) => addWorkFulfilled(response)),
      catchError(({response, status}) => of(returnErrors(response, status)))
    )
  )
);

export const updateWork = (id, work) => ({type: UPDATE_WORK, payload: work, id: id});
const updateWorkFulfilled = (payload) => ({type: UPDATE_WORK_FULFILLED, payload: payload});
export const updateWorkEpic = (action$, state$) => action$.pipe(
  ofType(UPDATE_WORK),
  debounceTime(500),
  withLatestFrom(state$),
  switchMap(([action, state]) => ajax.put(WORKS_API + `${action.id}/`, action.payload, apiHeader(state))
    .pipe(
      map(({response}) => updateWorkFulfilled(response)),
      catchError(({response, status}) => of(returnErrors(response, status)))
    )
  )
);

export const deleteWork = id => ({type: DELETE_WORK, id: id});
const deleteWorkFulfilled = (id) => ({type: DELETE_WORK_FULFILLED, payload: id});
export const deleteWorkEpic = (action$, state$) => action$.pipe(
  ofType(DELETE_WORK),
  debounceTime(500),
  withLatestFrom(state$),
  switchMap(
    ([action, state]) => ajax.delete(WORKS_API + `${action.id}/`, apiHeader(state))
      .pipe(
        map(() => deleteWorkFulfilled(action.id)),
        catchError(({response, status}) => of(returnErrors(response, status)))
      )
  )
);

export const resetRedirectWorkEpic = action$ => action$.pipe(
  ofType(ADD_WORK_FULFILLED, UPDATE_WORK_FULFILLED, DELETE_WORK_FULFILLED),
  mapTo({type: RESET_REDIRECT_WORK})
);

export const worksEpic = [
  fetchWorksEpic,
  newWorkEpic,
  fetchWorkEpic,
  addWorkEpic,
  updateWorkEpic,
  deleteWorkEpic,
  resetRedirectWorkEpic,
];